import { Directive, HostListener, OnInit, TemplateRef, ViewContainerRef } from "@angular/core";

@Directive()
export abstract class BaseScreenDirective implements OnInit {
    protected elseTmpl: TemplateRef<any>; // What template to render if size condition isn't met
    protected abstract readonly minWidth: number;

    constructor(protected tmpl: TemplateRef<any>, protected containerRef: ViewContainerRef) {}

    ngOnInit(): void {
        this.render();
    }

    @HostListener("window:resize")
    private render() {
        this.containerRef.clear();

        if (window.innerWidth >= this.minWidth) {
            this.containerRef.createEmbeddedView(this.tmpl);
        } else if (this.elseTmpl) {
            this.containerRef.createEmbeddedView(this.elseTmpl);
        }
    }
}
